import { render } from "./AttendeeList.vue?vue&type=template&id=0fe57de3"
import script from "./AttendeeList.vue?vue&type=script&lang=js"
export * from "./AttendeeList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__